import type { z } from 'zod'

import { PUBLIC_ENV_GLOBAL } from './public-env-global'
import type { createPublicEnv as createServerPublicEnv } from './server'

declare global {
    interface Window {
        [PUBLIC_ENV_GLOBAL]?: Readonly<Record<string, unknown>>
    }
}

// The return type ties this bundle to the server contract: tsc resolves apps against server.tsx.
export function createPublicEnv<Shape extends z.core.$ZodShape>(): ReturnType<typeof createServerPublicEnv<Shape>> {
    return {
        getPublicEnv() {
            const publicEnv = window[PUBLIC_ENV_GLOBAL]
            if (!publicEnv) {
                console.error(`window.${PUBLIC_ENV_GLOBAL} is missing: render <PublicEnv /> in the root layout`)
            }
            // global-error.tsx needs its fallback when the root layout fails.
            return (publicEnv ?? {}) as z.output<z.ZodObject<Shape>>
        },
        PublicEnv,
    }
}

// Only the server inserts the script; async to match the server signature.
function PublicEnv() {
    return Promise.resolve(null)
}
